import { AlertPrompt } from "../../feature/AlertPrompt/AlertPrompt";
import Spacer from "../../layout/Spacer/Spacer";

export const ErrorMessage = () => (
  <div>
    <Spacer />
    <AlertPrompt style="warning" title="SOMETHING WENT WRONG">Try again to claim the discount. </AlertPrompt>
  </div>
);
